import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {FaIcon} from "../FaIcon";
import AlertSnoozeWithOptionsInput from "../elements/AlertSnoozeWithOptionsInput";
import {URL_INDICATOR} from "./columns";
import {DATA_BY_STATUS_CODE, URL_STATUS_OK, URL_STATUS_RETRYING} from "../../urls";
import { withTranslation } from 'react-i18next';

export class UrlListModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            urlsInfo: null,
        };
    }

    componentDidMount() {
        this.getURLsStatusInfo();
    }

    getURLsStatusInfo() {
        const url = this.props.businessUnitAdAccountId !== null ? API_URL + `business-unit/ad_account/${this.props.businessUnitAdAccountId}/urls` : API_URL + `business-unit/${this.props.businessUnitId}/urls`

        new APIClient(url).call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    this.setState({
                        urlsInfo: response.data,
                    });
                } else {
                    alert(response.error_message)
                }
            })
            .catch((error) => {
                const { t } = this.props;
                alert(t('url_list_modal.error_occurred'))
            });
    }

    // rendering

    renderUrlsInformationTable() {
        const { t } = this.props;
        if (this.state.urlsInfo !== null) {
            return (
                <table className="table table-hover url-table">
                    <thead>
                    <tr>
                        <th style={{maxWidth:"440px"}}>{t('url_list_modal.url')}</th>
                        <th style={{width:"170px"}}>{t('url_list_modal.status')}</th>
                        <th>{t('url_list_modal.alert')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.urlsInfo.filter((urlInfo) => urlInfo.status === "down").map((urlInfo) => (
                        this.renderModalRow(urlInfo.url_id, urlInfo.url, urlInfo.status, urlInfo.status_code, urlInfo.last_checked, urlInfo.is_snoozed, urlInfo.snoozed_until)
                    ))}
                    {/* Rechazos: el servidor respondió pero no le mostró la página al chequeo. No avisan ni
                        cuentan como caídas; van arriba de las OK porque piden que alguien la abra. */}
                    {this.state.urlsInfo.filter((urlInfo) => urlInfo.status === URL_STATUS_RETRYING).map((urlInfo) => (
                        this.renderModalRow(urlInfo.url_id, urlInfo.url, urlInfo.status, urlInfo.status_code, urlInfo.last_checked, urlInfo.is_snoozed, urlInfo.snoozed_until)
                    ))}
                    {this.state.urlsInfo.filter((urlInfo) => urlInfo.status === "ok").map((urlInfo) => (
                        this.renderModalRow(urlInfo.url_id, urlInfo.url, urlInfo.status, urlInfo.status_code, urlInfo.last_checked, urlInfo.is_snoozed, urlInfo.snoozed_until)
                    ))}
                    {this.state.urlsInfo.filter((urlInfo) => urlInfo.status === "out of limit").map((urlInfo) => (
                        this.renderModalRow(urlInfo.url_id, urlInfo.url, urlInfo.status, urlInfo.status_code, "", urlInfo.is_snoozed, urlInfo.snoozed_until)
                    ))}
                    </tbody>
                </table>
            )
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    renderAlertSnoozeOptions(urlId, url, isSnoozed, snoozedUntil) {
        return <AlertSnoozeWithOptionsInput
            name={`alertSnoozeOptions-${urlId}!`}
            isSnoozed={isSnoozed}
            snoozedUntil={snoozedUntil}
            disabled={false}
            indicator={URL_INDICATOR}
            subIndicator={url}
        />
    }

    renderUrlWithBreaks(url) {
        // Split url into chunks of X characters
        const parts = url.match(/.{1,50}/g) || [];

        // Transform the parts into an array of strings and <br> elements
        const contentWithBreaks = parts.flatMap((part, index) => (index < parts.length - 1 ? [part, <br key={index} />] : part));

        return contentWithBreaks;
    }

    getStatusMessage(status, status_code) {
        const { t } = this.props;
        if(status === URL_STATUS_OK)
            return "OK";

        if(status === URL_STATUS_RETRYING)
            return <span>{t('url_list_modal.not_verified')}<br/><span style={{fontSize:"0.75em"}}>{t('url_list_modal.not_verified_reason')}</span></span>;

        // Un código sin texto propio igual dice cuál fue: «CAÍDA» a secas no deja saber el motivo.
        if(DATA_BY_STATUS_CODE[status_code] === undefined) {
            if (!status_code)
                return t('url_list_modal.down');
            return <span>{t('url_list_modal.url_down')}<br/><span style={{fontSize:"0.75em"}}>{t('url_list_modal.status_code', {code: status_code})}</span></span>;
        }

        return <span>{t('url_list_modal.url_down')}<br/><span style={{fontSize:"0.75em"}}>{DATA_BY_STATUS_CODE[status_code]["SpanishShort"]}</span></span>;
    }

    renderModalRow(urlId, url, status, status_code, last_check, isSnoozed, snoozedUntil) {
        const status_description = this.getStatusMessage(status, status_code);
        if (last_check !== "") {
            return (<tr key={url} className="pb-2">
                <td style={{maxWidth:"440px", height:"auto"}}><a href={url} target="_blank" rel="noopener noreferrer">{this.renderUrlWithBreaks(url)}</a></td>
                <td className={`status ${status}`} style={{width:"170px"}}>{status_description}<br/><span className="field-footnote">({last_check})</span></td>
                <td>{this.renderAlertSnoozeOptions(urlId, url, isSnoozed, snoozedUntil)}</td>
            </tr>)
        }
        else {
            return (<tr key={url}>
                <td><a href={url} target="_blank" rel="noopener noreferrer">{url}</a></td>
                <td className={`status ${status}`} colSpan={"2"}>{status}</td>
            </tr>)
        }
    }

    renderModalHeader() {
        const { t } = this.props;
        if (this.props.hasAlert) {
            return (
                <ModalHeader>
                    <FaIcon iconName="unlink" className="unlink"/>
                    <span className="unlink">{t('url_list_modal.down_urls')}</span>
                    <span>{this.props.title}</span>
                </ModalHeader>
            )
        } else {
            return (
                <ModalHeader>
                    <FaIcon iconName="link"/>
                    {t('url_list_modal.detected_urls_status')} <span>{this.props.title}</span>
                </ModalHeader>
            )
        }
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className="url-list-modal">
                {this.renderModalHeader()}
                <ModalBody>
                    <div className="modal-section pt-1">
                        {this.renderUrlsInformationTable()}
                    </div>
                </ModalBody>
                {/*<ModalFooter>*/}
                {/*<AltButton text="CLOSE"/>*/}
                {/*</ModalFooter>*/}
            </Modal>
        );
    }
}

export const UrlListModal = withTranslation()(UrlListModalClass);
export default UrlListModal;

